import { Color, Size, type Color as ColorType } from '@arritech/shared/types';
import type { IconNameOrString } from '../Icon/Icon.model';

export const CardType = {
	DEFAULT: 'default',
	RAISED: 'raised',
	OUTLINE: 'outline',
	GHOST: 'ghost',
	PLAIN: 'plain',
};

export const CardColor = Color;

type CardType = (typeof CardType)[keyof typeof CardType];

export interface CardMetadataItem {
	label: string;
	value?: string | number | boolean | null;
}

export interface BaseCardProps {
	/**
	 * The type of card to display
	 */
	type: CardType;

	/**
	 * The color theme of the card
	 */
	color: ColorType;

	/**
	 * The color theme of the card
	 */
	themeColor: ColorType;

	/**
	 * The title of the card
	 */
	title?: string;

	/**
	 * The subtitle of the card
	 */
	subTitle?: string;

	/**
	 * The description of the card
	 */
	description?: string;

	/**
	 * The category of the card
	 */
	category?: string;

	/**
	 ** Whether the card should be sticky
	 */
	sticky?: boolean;

	/**
	 * Whether the header should be sticky
	 **/
	stickyHeader?: boolean;

	/**
	 * The size of the card
	 */
	size: Size;

	/**
	 * The icon to display in the header
	 */
	icon?: IconNameOrString | null;

	/**
	 * Metadata to render in the card footer
	 */
	metadata?: CardMetadataItem[];

	/**
	 * Whether the card body can be collapsed. Requires a header (title,
	 * header slot, or actions slot) to click or to host the toggle button.
	 */
	collapsible?: boolean;

	/**
	 * Initial open state for an uncontrolled collapsible card. Ignored once
	 * `modelValue` is provided.
	 */
	defaultOpen?: boolean;

	/**
	 * Controlled open state for a collapsible card. Pair with
	 * `@update:modelValue` (or `v-model`) to drive it from the parent.
	 */
	modelValue?: boolean;
}
